import { actorPoints } from "@/mocks/home";

export default function ActorFocus() {
  return (
    <section id="actor" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
          <div className="order-2 h-72 w-full overflow-hidden rounded-lg border border-background-200/70 md:h-96 lg:order-1">
            <img
              src="https://readdy.ai/api/search-image?query=artistic%20silhouette%20of%20a%20martial%20artist%20mid%20motion%20in%20a%20shaft%20of%20warm%20light%2C%20dramatic%20chiaroscuro%20and%20floating%20dust%20particles%2C%20cinematic%20stylized%20composition%2C%20face%20not%20visible%2C%20deep%20amber%20and%20brown%20tones&width=900&height=1100&seq=master-actor-08&orientation=portrait"
              alt="武者在暖光中动作剪影的氛围示意图"
              className="h-full w-full object-cover object-top"
            />
          </div>

          <div className="order-1 lg:order-2">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              甄子丹 · 人物方向
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              动作之外，人物才是落脚点
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              提到甄子丹，多数人先想到的是功夫动作。但真正让他被记住的，往往不是招式本身有多难，而是他如何把角色的脾气放进动作里——出手快慢、停顿长短，其实都在交代人物是谁。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {actorPoints.map((p) => (
                <div key={p.title} className="rounded-lg bg-background-100 p-4">
                  <div className="flex items-center gap-3">
                    <span className="flex h-9 w-9 flex-none items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                      <i className={`${p.icon} text-lg`} />
                    </span>
                    <h3 className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                      {p.title}
                    </h3>
                  </div>
                  <p className="mt-3 text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {p.desc}
                  </p>
                </div>
              ))}
            </div>

            <p className="mt-6 rounded-md border border-background-200/70 bg-background-100 px-4 py-3 text-xs leading-relaxed text-foreground-500">
              说明：本页对人物的介绍为一般性概括，用于了解其动作与表演方向，不涉及具体作品的剧情细节，相关作品信息请以官方资料为准。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}